module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.41 13.007l4.59 4.58 4.59-4.58 1.41 1.41-6 6-6-6\"></path></svg>"